import styled from 'styled-components';

import {colors} from 'theme';

export const Root = styled.div`
    padding: 15px;
`;

export const Title = styled.div`
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 10px;
`;

export const Description = styled.div`
    margin-bottom: 20px;
`;

export const ErrorName = styled.div`
    font-size: 20px;
    margin-bottom: 10px;
    color: ${colors.danger};
`;

export const ErrorAreaRoot = styled.div`
    padding: 20px;
    border-radius: 4px;
    background-color: #f9f9f9;
`;

export const ErrorArea = styled.div`
    max-height: 300px;
    overflow: auto;
    user-select: all;
`;

export const ErrorStack = styled.div`
    white-space: pre-wrap;
`;
